var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"content-loading"},[_c('a-spin',[(_vm.loadingText)?_c('div',{staticClass:"spin-content"},[_vm._v(_vm._s(_vm.loadingText))]):_vm._e()])],1):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }